import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Button } from '@mui/material';
import useCaptureButtonStyles from './useCaptureButtonStyles';
const CaptureButton = ({ onClick }) => {
    const styles = useCaptureButtonStyles();
    return (_jsx(Box, { className: 'capture-btn-container', sx: styles.CameraButtonContainer, onClick: onClick, children: _jsx(Button, { className: 'capture-btn-outter', sx: styles.CaptureButton, children: _jsx(Box, { className: 'capture-btn-inner', sx: styles.CaptureButtonInner }) }) }));
};
export default CaptureButton;
